import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { GetRequestEventLogResponse } from '@app/generated-api';
import { DateFormat } from '@models/date-format';
import moment, { utc } from 'moment';
@Component({
    selector: 'medpace-request-history-post',
    standalone: false,
    templateUrl: './request-history-post.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./request-history-post.component.scss'],
})
export class RequestHistoryPostComponent {
    //Note: Post time can be different than showed in history table, as in history table dates are represented in UTC timezone.
    // In this component time is represented in local timezone. For example, 12:00pm in London -> 7:00am in Cincinnati
    DateFormat = DateFormat;

    postInfo = input.required<GetRequestEventLogResponse>();

    offset = moment().utcOffset();

    postTime = computed(() => {
        const item = this.postInfo();
        if (!item) return;

        return utc(item.occurredOn).utcOffset(this.offset).toISOString();
    });

    getPostMessage = computed(() => {
        const item = this.postInfo();
        if (!item) return;

        const message = item.details
            ? `${item.info} with note "${item.details}" by ${item.triggeredBy}`
            : `${item.info} by ${item.triggeredBy}`;

        return item.triggeredByEmail ? `${message} (${item.triggeredByEmail})` : message;
    });
}
